import {post, get, remove, patch} from '@/lib/axios';

const ideas_bank = {
  async get_ideas() {
    return get(`/idea`);
  },
  async post_idea(data) {
    return post(`/idea`, data);
  },
  async get_idea_comments(id) {
    return get(`/idea/${id}/comment`);
  },
  async post_idea_comment(id, data) {
    return post(`/idea/${id}/comment`, data);
  },
  async edit_idea_comment(id, data) {
    return patch(`/idea/comment/${id}`, data);
  },
  async delete_idea_comment(id) {
    return remove(`/idea/comment/${id}`);
  },
  async like_idea(id, data) {
    return post(`/idea/${id}/like`, data);
  },
  async unlike_idea(id, data) {
    return remove(`/idea/${id}/like`, data);
  },
};

export {ideas_bank as default};
